// webapp/src/components/InviteTokenRedirect.tsx
//
// Phase 31.6 Plan 02 — FE-31-11 (react-refresh/only-export-components).
// Extracted out of main.tsx so the entry module (createRoot side-effect) no
// longer also defines a component — clears the react-refresh lint flag.
//
// Detects Supabase invite tokens that land at the site root (implicit-flow
// redirect) and forwards them to /auth/callback so the invite handler runs.
// Renders nothing; stays eager (outside <Routes>, mounts once at app root).

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function InviteTokenRedirect() {
  const navigate = useNavigate()
  useEffect(() => {
    const hash = window.location.hash
    if (hash.includes('type=invite') && hash.includes('access_token=')) {
      navigate(`/auth/callback?admin=true${hash}`, { replace: true })
    }
  }, [navigate])
  return null
}
